/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    bool, func, string, object,
    arrayOf, shape, number,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import mbpLogger from '@module-logger/mbp';
import { withStyles } from '@material-ui/core/styles';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';
import { getBrand, getCustomerEmail } from '../../../state/ducks/Common/Common-Selectors';
import { isEmpty } from '../../../utils/object';

import SubscriptionList from './SubscriptionList';
import AccountHome from '../../MyAccount/AccountHome';

const { PERSIST_KEY } = configENV;

const styles = () => ({
    defaultBody: {
        paddingBottom: '20px',
        color: '#666',
        '@media screen and (min-width: 768px)': {
            padding: '0 30px',
        },
    },
    header: {
        marginBottom: '19px',
        height: '29px',
    },
});

class MobileSubscriptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            subscriptionsList: [],
            page: 0,
        };

        const {
            customerId, fetchSubscriptions, brand, subscriptions, featureFlags,
        } = props;
        const { page } = this.state;
        if (isEmpty(subscriptions)) fetchSubscriptions({ customerId, page }, brand, subscriptions, featureFlags);  // fetch subscriptions into newState
    }

    static getDerivedStateFromError(/* error */) {
        return { hasError: true };
    }

    componentDidCatch = (jsError, reactInfo) => {
        mbpLogger.logError({
            message: `Unhandled Error in MobileSubscriptions \n jsError = ${jsError} \n reactInfo = ${reactInfo}`,
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
        });
    }

    handleCancelSubscription = (subscriptionRuleId) => {
        const { cancelSubscription, brand } = this.props;
        cancelSubscription(subscriptionRuleId, brand);
    }

    handleUpdateSubscription = (updateType, subscriptionRuleId) => {
        const {
            updateSubscription, brand, featureFlags,
        } = this.props;
        updateSubscription(subscriptionRuleId, brand, featureFlags, updateType);
    }

    hanldeLoadMore = () => {
        const {
            customerId, fetchSubscriptions, brand, subscriptions, featureFlags,
        } = this.props;
        const { page } = this.state;
        this.setState({ page: page + 1 }, () => fetchSubscriptions({ customerId, page: page + 1 }, brand, subscriptions, featureFlags));
    }

    render() {
        const { subscriptionsList, error, hasError } = this.state;
        const {
            isFetchingModal, classes, featureFlags,
        } = this.props;

        if (error || hasError) {
            return <div>Sorry! - we were unable to access your subscriptions.<br />Please try again later.</div>;
        }

        return (
            <div className={classes.defaultBody}>
                <div className={classes.header}><h1><AccountHome disablePageView /> Manage Subscriptions</h1></div>
                <SubscriptionList
                    subscriptions={subscriptionsList}
                    featureFlags={featureFlags}
                    handleCancel={this.handleCancelSubscription}
                    handleUpdate={this.handleUpdateSubscription}
                    hanldeLoadMore={this.hanldeLoadMore}
                    isFetchingModal={isFetchingModal}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        brand: getBrand(state),
        customerId: getCustomerEmail(state),
        subscriptions: newState.subscriptions,
        subscriptionResMsg: newState.subscriptionResMsg,
    };
};

MobileSubscriptions.defaultProps = {
    fetchSubscriptions: () => { },
    cancelSubscription: () => { },
    updateSubscription: () => { },
    subscriptions: [],
};

MobileSubscriptions.propTypes = {
    customerId: string.isRequired,
    isFetchingModal: bool.isRequired,
    fetchSubscriptions: func,
    cancelSubscription: func,
    updateSubscription: func,
    brand: object.isRequired,
    subscriptions: arrayOf(
        shape({
            checkoutBrand: string,
            duration: number.isRequired,
            endDate: string.isRequired,
            interval: number.isRequired,
            nextOrderDate: string,
            orderDate: string.isRequired,
            orderHistoryResult: arrayOf(
                shape({
                    deliveryDate: string,
                    discountAmount: string,
                    orderDate: string.isRequired,
                    orderNumber: string.isRequired,
                    productCode: string.isRequired,
                    productName: string.isRequired,
                    productPrice: string.isRequired,
                    quantity: string.isRequired,
                }),
            ),
            orderNumber: string.isRequired,
            orderTime: string.isRequired,
            orderType: string.isRequired,
            price: string.isRequired,
            productId: string.isRequired,
            productImageCategory: string.isRequired,
            productImageThumbnail: string.isRequired,
            productName: string.isRequired,
            quantity: string,
            recipient: arrayOf(shape({
                city: string.isRequired,
                country: string.isRequired,
                firstName: string.isRequired,
                lastName: string.isRequired,
                state: string.isRequired,
                street1: string.isRequired,
                street2: string.isRequired,
                zipcode: string.isRequired,
            })),
            ruleId: string.isRequired,
            startDate: string.isRequired,
            subscriptionStatus: string.isRequired,
            totalAmount: string.isRequired,
        }),
    ),
    classes: object.isRequired,
    featureFlags: shape({
        'is-subscription-skip': bool,
        'is-subscription-pause': bool,
        'is-subscription-frequency': bool,
    }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    fetchSubscriptions: (customerId, brand, subscriptions, featureFlags) => dispatch(EventDispatcher.fetchSubscriptions(customerId, brand, subscriptions, featureFlags)),
    cancelSubscription: (ruleId, brand, featureFlags) => dispatch(EventDispatcher.cancelSubscription(ruleId, brand, featureFlags)),
    updateSubscription: (ruleId, brand, featureFlags, updateType) => dispatch(EventDispatcher.updateSubscription(ruleId, brand, featureFlags, updateType)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles, { withTheme: true })(MobileSubscriptions)));
